<script>
/**
 * Componente de gráfico de línea en PDF Programado.
 * --------------------------------------------
 *
 * Este componente dibuja un gráfico a partir de la data recibida.
 *
 */
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: ["data", "single", "hourAverage"],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
          labels: {
            fontSize: 6
          }
        }
      }
    };
  },
    /**
     * Renderiza el Pie chart
     */
  mounted() {
    this.renderLineChart();
  },
  methods: {
    /**
     * Método que calcula las horas excedidas por mes para poder dibujar en el chart el porcentaje correspondiente.
     */
    excedeedHours() {
      for (const el in this.data) {
        if (Object.hasOwnProperty.call(this.data, el)) {
          const element = this.data[el];
          if (element.type === "line" && element.influxId === this.single) {
            let hourExceededCount = 0;
            let lastMonth = [...element.sensor_data].reverse().slice(-31);
            lastMonth.forEach(sensor => {
              if (sensor[1] >= this.hourAverage) {
                hourExceededCount++;
              }
            });

            return (hourExceededCount * 100) / lastMonth.length;
          }
        }
      }
    },
    renderLineChart() {
      this.renderChart(
        {
    /**
     * Labels de cada pie chart
     */
          labels: [
            `${this.$i18n.t("report_pdf_exceeded")} ${
              this.single === "PM10"
                ? this.$i18n.t("report_pdf_days")
                : this.$i18n.t("report_pdf_hours")
            }`,
            `${this.$i18n.t("report_pdf_not_exceeded")} ${
              this.single === "PM10"
                ? this.$i18n.t("report_pdf_days")
                : this.$i18n.t("report_pdf_hours")
            }`
          ],
          datasets: [
            {
    /**
     * color de horas excedidas y horas no excedidas, añadimos en la data las horas excedidas y las que no lo han sido.
     */
              backgroundColor: ["#E45035", "#70AD47"],
              data: [this.excedeedHours(), 100 - this.excedeedHours()]
            }
          ]
        },
        this.options
      );
    }
  },
  watch: {
    data: function() {
      this.$data._chart.destroy();
      this.renderLineChart();
    }
  }
};
</script>
